import ls from 'localstorage-slim';
import React, { useEffect } from 'react';
import { RouteProps, useNavigate } from 'react-router-dom';
import useThemeHook from '../../../hooks/useThemeHook';
import { setHasNewOffer } from '../../../redux/cache-slice';
import { clearCarData } from '../../../redux/leaseApp/lease-app-slice';
import { useAppDispatch } from '../../../redux/store';
import { MarketingData, Partner, Type } from '../../../types/instant-lease-api';

const SummaryB2C: React.FC<RouteProps> = () => {
  const searchParams = new URLSearchParams(document.location.search);
  const partner = searchParams.get('partner');
  const offerId = searchParams.get('offerId')?.trim();
  const publicationId = searchParams.get('publicationId');
  const pricingId = searchParams.get('pricingId');
  const loyaltyId = searchParams.get('loyaltyId');
  const loyaltyType = searchParams.get('loyaltyType');
  const marketingDataJson = searchParams.get('marketingData');
  const vin = searchParams.get('vin');
  const type = searchParams.get('type');
  const offerRefId = searchParams.get('offerRefId');

  // We may receive JSON-encoded marketing campaign tracking data, so we need
  // to parse it first
  const marketingData = marketingDataJson
    ? (JSON.parse(marketingDataJson) as MarketingData)
    : undefined;

  // Navigate Hook
  const navigate = useNavigate();

  // Dispatch hook
  const dispatch = useAppDispatch();

  // Verify Partner
  const verifyPartner = () => {
    if (
      Object.values(Partner).includes(
        (partner ? partner.toUpperCase() : Partner.ALD) as Partner,
      )
    ) {
      return partner ? partner.toUpperCase() : Partner.ALD;
    }
    return 'ald_marktplatz';
  };

  useThemeHook(verifyPartner());

  useEffect(() => {
    const value = {
      offerId,
      partner,
      publicationId,
      pricingId,
      loyaltyId,
      vin,
      loyaltyType,
      marketingData,
      offerRefId: offerRefId || undefined,
      type: Type.B2C,
    };

    ls.set('oid', value);
    ls.set('carData', { pricingId, publicationId });
    ls.set('loyaltyType', { loyaltyType });
    ls.set('vin', { vin });
    ls.set('type', { type });
    dispatch(clearCarData());
    dispatch(setHasNewOffer(true));

    if ((pricingId && publicationId) || offerId) {
      navigate(
        `/start?partner=${partner || ''}&publicationId=${
          publicationId || ''
        }&pricingId=${pricingId || ''}&loyaltyType=${
          loyaltyType || ''
        }&offerId=${offerId || ''}&type=${type || ''}&vin=${vin || ''}&offerRefId=${offerRefId || ''}`,
      );
    } else {
      navigate('/login');
    }
  }, [
    dispatch,
    navigate,
    offerId,
    partner,
    publicationId,
    pricingId,
    loyaltyId,
    vin,
    loyaltyType,
    type,
    offerRefId,
    marketingData,
  ]);

  return <></>;
};

export default SummaryB2C;
